<div *ngFor="let item of items">
    <input type="checkbox" [id]="item.name" [checked]="item.checked" (change)="toggleSelection(item); emit()">
    <label [for]="item.name" > {{ item.name | titlecase }}</label>
  </div>
